import { themeAtom } from "../../shared/atoms";
import { ItinaryAndCargo, VoyageItineraryM } from "../models/voyage.interfaces";
import { useAtomValue } from "jotai";
import { Fragment } from "react";
import { twMerge } from "tailwind-merge";

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

function LabelValue({ label, value }: { label: string; value: string }) {
  const theme = useAtomValue(themeAtom);

  return (
    <div>
      <div className={twMerge("text-custom-label text-[11px] font-normal", theme.vesselDetails.fields)}>{label}</div>
      <div className={twMerge("text-custom-value text-xs font-normal", theme.home.tailwind.textDefault)}>{value}</div>
    </div>
  );
}

export function CargoDetailsFactory(itinaryInfoData: ItinaryAndCargo | null) {
  const theme = useAtomValue(themeAtom);

  return (item: VoyageItineraryM) => {
    if (item.VI_PORT_FUNC !== "L" && item.VI_PORT_FUNC !== "D") {
      return null;
    }

    const cargo = itinaryInfoData?.cargoLoadDischarge.filter(
      (cargoitem) =>
        cargoitem.CARGO_ITINERARY_PORT_FUNC === item?.VI_PORT_FUNC &&
        cargoitem.CARGO_ITINERARY_PORT_NAME === item?.VI_PORT_NAME,
    );

    return (
      <div
        className={twMerge(
          "grid grid-cols-3 gap-4 p-2",
          theme.voyageItinerary.detailsBackground,
          theme.home.tailwind.textDefault,
        )}
      >
        <LabelValue label="ETA" value={item.ETA_LOAD_DISCHARGE ? formatDate(item.ETA_LOAD_DISCHARGE) : "-"} />
        <LabelValue label="ETB" value={item.ETB_LOAD_DISCHARGE ? formatDate(item.ETB_LOAD_DISCHARGE) : "-"} />
        <LabelValue label="ETD" value={item.ETD_LOAD_DISCHARGE ? formatDate(item.ETD_LOAD_DISCHARGE) : "-"} />

        {item.VI_PORT_FUNC === "L" ? (
          <>
            <LabelValue
              label="Commenced loading"
              value={item?.COMM_LOAD_DISCHARGE ? formatDate(item.COMM_LOAD_DISCHARGE) : "-"}
            />
            <LabelValue
              label="Completed loading"
              value={item?.COMPL_LOAD_DISCHARGE ? formatDate(item.COMPL_LOAD_DISCHARGE) : "-"}
            />
            <div>
              <div className={twMerge("text-custom-label text-[11px] font-normal", theme.vesselDetails.fields)}>
                B/L Date
              </div>
              {cargo && cargo.length > 0 ? (
                cargo.map((cargoitem, index) => (
                  <div key={index} className={twMerge("text-xs font-normal", theme.home.tailwind.textDefault)}>
                    {cargoitem?.BL_DATE
                      ? new Date(cargoitem.BL_DATE).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : "-"}
                  </div>
                ))
              ) : (
                <div className={twMerge("text-xs font-normal", theme.home.tailwind.textDefault)}>-</div>
              )}
            </div>
          </>
        ) : (
          <>
            <LabelValue
              label="Commenced discharging"
              value={item?.COMM_LOAD_DISCHARGE ? formatDate(item.COMM_LOAD_DISCHARGE) : "-"}
            />
            <LabelValue
              label="Completed discharging"
              value={item?.COMPL_LOAD_DISCHARGE ? formatDate(item.COMPL_LOAD_DISCHARGE) : "-"}
            />
          </>
        )}

        {cargo?.map((cargoitem, index) => (
          <Fragment key={index}>
            <LabelValue label="Quantity" value={String(cargoitem.QUANTITY)} />
            <LabelValue label="Rate" value={String(cargoitem.RATE)} />
            <LabelValue label="Turn time" value={cargoitem.TURN_TIME ? `${cargoitem.TURN_TIME} hours` : "-"} />
            <LabelValue label="Terms" value={cargoitem.TERMS || "-"} />
          </Fragment>
        ))}
      </div>
    );
  };
}
